import { render, staticRenderFns } from "./SyntheseDisplay.vue?vue&type=template&id=795efb88&"
import script from "./SyntheseDisplay.vue?vue&type=script&lang=js&"
export * from "./SyntheseDisplay.vue?vue&type=script&lang=js&"
import style0 from "./SyntheseDisplay.vue?vue&type=style&index=0&id=795efb88&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports